import Option from './option'
// import transformation from './transformer'
// import CommonModule from '@api/module/common/common/CommonModule'

export default {
  desc: '培训年度',
  mixins: [Option],
  computed: {
    list() {
      return []
      // return transformation.transformation(CommonModule.getYearList)
    }
  }
}
